export const resources = [
  {
    label: "Job Opportunities",
    href: "https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=1ad5f229-7e85-4993-8c86-672e31079f3b&ccId=19000101_000001&type=MP&lang=en_US",
  },
  { label: "Marketplace", href: "https://marketplace.goldenpaints.com/" },
  { label: "Privacy Policy", href: "/privacy-policy" },
];
